/* FG: keep main-product custom fields (name, message...) off free/bundled (BOGO / Festive Offer / free gift) cart lines. */
(function () {
  if (window.__fgLinePropsGuard) return; window.__fgLinePropsGuard = 1;
  var of = window.fetch;
  if (!of) return;

  /* 1) Before the request leaves: drop properties copied from the first item onto the other items of one /cart/add call. */
  function cleanBody(body) {
    try {
      if (typeof body !== 'string' || body.charAt(0) !== '{') return body;
      var p = JSON.parse(body);
      if (!p || !p.items || p.items.length < 2) return body;
      var main = p.items[0], mp = main.properties;
      if (!mp || typeof mp !== 'object') return body;
      var mps = JSON.stringify(mp), changed = false;
      for (var i = 1; i < p.items.length; i++) {
        var it = p.items[i];
        if (it && String(it.id) !== String(main.id) && it.properties && JSON.stringify(it.properties) === mps) {
          delete it.properties; changed = true;
        }
      }
      return changed ? JSON.stringify(p) : body;
    } catch (e) { return body; }
  }

  /* 2) After the add: any free line that carries the same properties as a paid line gets them cleared. */
  function isFree(i) {
    if (/festive offer/i.test(i.product_title || i.title || '')) return true;
    if ((i.discounts || []).some(function (d) { return /bogo|free/i.test(d.title || ''); })) return true;
    if ((i.line_level_discount_allocations || []).some(function (d) {
      return /bogo/i.test((d.discount_application && d.discount_application.title) || '');
    })) return true;
    return i.original_line_price > 0 && i.final_line_price === 0;
  }
  function hasProps(i) { return i.properties && Object.keys(i.properties).length > 0; }

  function cleanup(n) {
    n = n || 0;
    if (n > 6) return Promise.resolve();
    return of('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var paid = items.filter(function (i) { return !isFree(i) && hasProps(i); });
        if (!paid.length) return;
        for (var idx = 0; idx < items.length; idx++) {
          var it = items[idx];
          if (!isFree(it) || !hasProps(it)) continue;
          var np = {}, changed = false;
          Object.keys(it.properties).forEach(function (k) {
            var dup = paid.some(function (p) { return p.properties[k] === it.properties[k]; });
            if (dup) { np[k] = ''; changed = true; } else { np[k] = it.properties[k]; }
          });
          if (!changed) continue;
          return of('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: idx + 1, properties: np })
          }).then(function () { return cleanup(n + 1); });
        }
      })
      .catch(function () {});
  }

  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }

  window.fetch = function (input, init) {
    var add = false;
    try {
      var u = typeof input === 'string' ? input : (input && input.url);
      add = isAdd(u);
      if (add && init && init.body) init = Object.assign({}, init, { body: cleanBody(init.body) });
    } catch (e) {}
    var p = of.call(this, input, init);
    if (!add) return p;
    return p.then(function (res) {
      return cleanup().then(function () { return res; }, function () { return res; });
    });
  };

  var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__fgAdd = isAdd(u); return oo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (b) { return os.call(this, this.__fgAdd ? cleanBody(b) : b); };

  document.addEventListener('DOMContentLoaded', function () { cleanup(); });
})();
